import { render, staticRenderFns } from "./EmailCheckout.vue?vue&type=template&id=5d38e18a&"
import script from "./EmailCheckout.vue?vue&type=script&lang=js&"
export * from "./EmailCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports